import React, {useEffect, useState} from 'react'
import Header from "../../../../layout/header";
import BottomMenu from "../../../../layout/bottomMenu";
import "../../../../Dashboard/Dashboard.css";
import "../../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUpload from "../../../../FileUploads/FileUpload";
import './raise_payment.css'
import {loanApprovalRequestRequest} from "../../../../../service/Dealer/action";

const RaisePayment = ({
                          match,
                          history,
                          documentUploadUrlPublic,
                          documentUrlDataPublic,
                          bankListResponse = [],
                          bankListRequest,
                          loanUndertakingRequest,
                          loanAccountRequest,
                          loanPaymentRaiseRequest,
                          loanAccountResponse = [],
                          loanUndertakingResponse = [],
                          loanPaymentRaiseResponse = [],
                          loanTranchesRequest,
                          loanTranchesResponse = [],
                          loanPaymentRaiseUpdateRequest,
                          loanApplicationUpdateResponse = [],
                          loanApplicationByIdRequest,
                          ucdCaseByIdResponse = [],
                          loanApprovalRequestRequest,
                          loanApprovalRequestResponse,
                          loanPaymentRaiseUpdateResponse = []
                      }) => {
    const [inputList, setInputList] = useState([{
        payment_details: {
            existing_loan: '',
            for_closure_amount: '',
            fc_closure_amount_proof: '',
            prev_loan_closure: '',
            mode_of_payment: '',
            loan_amount_from_bank: '',
            utr_no: '',
            loan_closure_payment_proof: '',
            disbursal_date: '',
            disbursal_memo: '',
        },
        dealer_details: {
            account_number: '',
            bank_name: '',
            ifsc_code: '',
            branch_name: '',
        },
        hold_back_Details: {
            amount_approval_proof: '',
            amount: '',
            account_id: '',
            mode_of_payment: '',
            remark: '',
        },
        undertaking:{
            undertaking:''
        }
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [stage, setStage] = useState(1);
    const [tranches, setTranches] = useState([{amount: '', account_id: '', payment_mode: '', remark: ''}])
    const [amountReceived, setAmountReceived] = useState(0);
    const [checkDisbursalMemo, setCheckDisbursalMemo] = useState(false);
    const [closureAmountProof, setClosureAmountProof] = useState('');
    const [loanClosureProof, setLoanClosureProof] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await bankListRequest()
            await loanAccountRequest(match?.params?.id)
            await loanTranchesRequest(match?.params?.id)
            await loanApplicationByIdRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])


    const handleInput = (val, index, e = '', key = '') => {
        const list = [...inputList]
        list[0][key][index] = '';
        list[0][key][index] = val
        setInputList(list)
    }

    const handleSubmit = async (e, isFinalSubmit = false) => {
        e.preventDefault()
        if(stage < 5){
            return false;
        }

        let requestParams = inputList[0];
        if(!requestParams['payment_details']['existing_loan']){
            requestParams['payment_details']['existing_loan'] = ucdCaseByIdResponse?.data?.existing_loan ? "Yes": "No"
        }

        if(!requestParams['payment_details']['for_closure_amount']){
            requestParams['payment_details']['for_closure_amount'] = ucdCaseByIdResponse?.data?.fore_closure_amount
        }

        if(!requestParams['payment_details']['fc_closure_amount_proof']){
            requestParams['payment_details']['fc_closure_amount_proof'] = ucdCaseByIdResponse?.data?.fore_closure_amount_proof
        }

        if(!requestParams['payment_details']['prev_loan_closure']){
            requestParams['payment_details']['prev_loan_closure'] = ucdCaseByIdResponse?.data?.previous_loan_closed_by
        }

        if(!requestParams['payment_details']['mode_of_payment'] && requestParams['payment_details']['prev_loan_closure'] === 'Bank'){
            requestParams['payment_details']['mode_of_payment'] = ucdCaseByIdResponse?.data?.mode_of_payment
        }

        if(!requestParams['payment_details']['loan_amount_from_bank']){
            requestParams['payment_details']['loan_amount_from_bank'] = ucdCaseByIdResponse?.data?.loan_amount_received_from_bank
        }

        if(!requestParams['payment_details']['utr_no']){
            requestParams['payment_details']['utr_no'] = ucdCaseByIdResponse?.data?.bank_transfer_utr_number
        }

        if(!requestParams['payment_details']['loan_closure_payment_proof']){
            requestParams['payment_details']['loan_closure_payment_proof'] = ucdCaseByIdResponse?.data?.loan_closure_payment_proof
        }

        if(!requestParams['hold_back_Details']['account_id']){
            requestParams['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
        }

        if(!requestParams['hold_back_Details']['mode_of_payment']){
            requestParams['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
        }

        if(!requestParams['hold_back_Details']['remark']){
            requestParams['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
        }

        if(!requestParams['hold_back_Details']['amount']){
            requestParams['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount;
        }

        if(!requestParams['hold_back_Details']['amount_approval_proof']){
            requestParams['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof ;
        }

        if(!requestParams['undertaking']['undertaking']){
            requestParams['undertaking']['undertaking'] = ucdCaseByIdResponse?.data?.customer_undertaking ;
        }

        if(parseInt(requestParams['payment_details']['loan_amount_from_bank']) > 2000000 && !requestParams['hold_back_Details']['amount_approval_proof']){
            toast.error("Hold back amount  proof is missing!");
            return false;
        }
        requestParams['tranches'] = tranches;
        requestParams['case_id'] = match?.params?.id;
        setIsLoading(true);
        if(ucdCaseByIdResponse?.data?.loan_amount_received_from_bank){
            console.log("update")
            await loanPaymentRaiseUpdateRequest(requestParams)
        } else {
            console.log("create")
            await loanPaymentRaiseRequest(requestParams)
        }

        setIsLoading(false);
    }

    const handleAddTranches = (e) => {
        e.preventDefault();
        setTranches([
            ...tranches, {amount: '', account_id: '', payment_mode: '', remark: ''}
        ]);
    }

    const handleRemoveTranches = (e, index) => {
        e.preventDefault();
        let list = [...tranches]
        list.splice(index, 1);
        setTranches(list)
    }

    const handleTrancheInput = (val, key, index) => {
        const list = [...tranches]
        list[index][key] = val
        setTranches(list)
    }

    const handleStage = stageNo => {
        let list = [...inputList];
        let isTrue = false;
        setCheckDisbursalMemo(false);

        let errorMsg = '';
        if(stageNo === 3){
            if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 2000000 && !inputList[0]['hold_back_Details']['amount_approval_proof']){
                toast.error("Hold back amount  proof is missing!");
                return false;
            }

        }

        if(stageNo === 3){
            if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000
                && (parseInt(inputList[0].hold_back_Details['amount']) > 20000 || parseInt(inputList[0].hold_back_Details['amount']) < 20000)
                && !inputList[0]['hold_back_Details']['amount_approval_proof']){
                toast.error("Hold back amount  proof is missing!");
                return false;
            }
        }

        if(stageNo === 3){
            if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000 &&  parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) < 2000000
                && (parseInt(inputList[0].hold_back_Details['amount']) > 40000 || parseInt(inputList[0].hold_back_Details['amount']) < 40000)
                && !inputList[0]['hold_back_Details']['amount_approval_proof']){
                toast.error("Hold back amount  proof is missing!");
                return false;
            }
        }

        if(ucdCaseByIdResponse?.data?.loan_amount_received_from_bank){
            setStage(stageNo)
            return false;
        }


        if (stageNo - 1 === 1) {
            Object.keys(list[0].payment_details).forEach((key) => {
                if (list[0].payment_details['existing_loan'] === 'No') {
                    isTrue = !list[0].payment_details['loan_amount_from_bank'];
                    isTrue = !list[0].payment_details['utr_no'];
                } else {
                    if (!list[0].payment_details[key]) {
                        errorMsg = key.charAt(0).toUpperCase().replaceAll("_"," ") + key.slice(1).replaceAll("_"," ")+" is required";
                        isTrue = true;
                    }
                }
                isTrue = !list[0].payment_details['disbursal_date'];
                if(!list[0].payment_details['disbursal_memo']){
                    setCheckDisbursalMemo(true)
                    isTrue = true
                }
            })
        }



        // if (stageNo - 1 === 2) {
        //     Object.keys(list[0].dealer_details).forEach((key) => {
        //         if (!list[0].dealer_details[key]) {
        //             isTrue = true;
        //         }
        //     })
        // }

        if (stageNo - 1 === 3) {
            Object.keys(list[0].hold_back_Details).forEach((key) => {
                if (!list[0].hold_back_Details[key] && key !== 'amount_approval_proof' && key !== 'status') {
                    isTrue = true;
                }

                if(parseInt(amountReceived) !== parseInt(list[0].hold_back_Details['amount']) && key === 'amount_approval_proof' && !list[0].hold_back_Details[key]){
                    errorMsg = "Document for amount proof is required!";
                    isTrue = true;
                }
            })
        }

        if (stageNo - 1 === 4) {
            console.log(tranches)
            tranches.map(val => {
                console.log(val)
                Object.keys(val).forEach((key) => {
                    if (!val[key]) {
                        isTrue = true;
                        errorMsg = `${key} is missing!`;
                    }
                })
            })
        }
        if(isTrue && errorMsg){
            toast.error(errorMsg)
        }
        isTrue ? setStage(stageNo - 1) : setStage(stageNo);
        // setCheckDisbursalMemo(false);
    }

    // useEffect(() => {
    //     if(loanAccountResponse?.DEALER){
    //         let list = [...inputList];
    //         list[0]['dealer_details'] = {
    //             account_number: loanAccountResponse?.DEALER?.account_number,
    //             bank_name: loanAccountResponse?.DEALER?.bank_name,
    //             ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
    //             branch_name: loanAccountResponse?.DEALER?.branch_name,
    //         };
    //         setInputList(list)
    //     }
    // }, [loanAccountResponse])

    useEffect(() => {
        if(parseInt(loanPaymentRaiseResponse?.status) === 200){
            toast.success(loanPaymentRaiseResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`
        } else if(parseInt(loanPaymentRaiseResponse?.status) !== 200){
            toast.error(loanPaymentRaiseResponse?.message);
        }
    }, [loanPaymentRaiseResponse])

    useEffect(() => {
        if(parseInt(loanApplicationUpdateResponse?.status) === 200){
            toast.success(loanApplicationUpdateResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`
        } else if(parseInt(loanApplicationUpdateResponse?.status) !== 200){
            toast.error(loanApplicationUpdateResponse?.message);
        }
    }, [loanApplicationUpdateResponse])


    useEffect(() => {
        if(loanTranchesResponse?.data ){
            let list = [...inputList];

            if(loanTranchesResponse?.data?.HOLD_BACK_TRANCHE){
                list[0]['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
                list[0]['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
                list[0]['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
                if(loanTranchesResponse?.data?.TRANCHES.length > 0 ){
                    setTranches(loanTranchesResponse?.data?.TRANCHES)
                }
            }

            list[0]['dealer_details'] = {
                account_number: loanAccountResponse?.DEALER?.account_number,
                bank_name: loanAccountResponse?.DEALER?.bank_name,
                ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
                branch_name: loanAccountResponse?.DEALER?.branch_name,
            };

            if(ucdCaseByIdResponse?.data){
                list[0]['payment_details'] = {
                    existing_loan: ucdCaseByIdResponse?.data?.existing_loan ? "Yes": "No",
                    for_closure_amount: ucdCaseByIdResponse?.data?.fore_closure_amount,
                    // fc_closure_amount_proof: ucdCaseByIdResponse?.data?.fore_closure_amount_proof,
                    mode_of_payment: ucdCaseByIdResponse?.data?.mode_of_payment,
                    loan_amount_from_bank: ucdCaseByIdResponse?.data?.loan_amount_received_from_bank,
                    utr_no: ucdCaseByIdResponse?.data?.bank_transfer_utr_number,
                    // loan_closure_payment_proof: ucdCaseByIdResponse?.data?.loan_closure_payment_proof,
                    prev_loan_closure: ucdCaseByIdResponse?.data?.previous_loan_closed_by,
                    disbursal_memo: ucdCaseByIdResponse?.data?.disbursal_memo,
                    disbursal_date: ucdCaseByIdResponse?.data?.disbursal_date,
                };

                list[0]['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount ?? null;
                list[0]['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof ;
            }
            setInputList(list)
        }
    }, [loanTranchesResponse, ucdCaseByIdResponse, loanAccountResponse]);

    // useEffect(() => {
    //     if(ucdCaseByIdResponse?.data){
    //         setTimeout(() => {
    //             let list = [...inputList];
    //
    //             setInputList(list)
    //         }, 500)
    //     }
    // }, [ucdCaseByIdResponse]);

    const handlePaymentRelease = async () => {
        setIsLoading(true)
        await loanApprovalRequestRequest({loan_id: match?.params?.id, status: "REQUEST_FOR_PAYMENT_RELEASE"})
        setIsLoading(false)
    }

    console.log('123432',loanPaymentRaiseUpdateResponse)
    useEffect(() => {
        if(parseInt(loanPaymentRaiseUpdateResponse?.status) === 200){
            toast.success(loanPaymentRaiseUpdateResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`
        } else if(parseInt(loanPaymentRaiseUpdateResponse?.status) !== 200){
            toast.error(loanPaymentRaiseUpdateResponse?.message);
        }
    }, [loanPaymentRaiseUpdateResponse])

    useEffect(() => {
        if(parseInt(loanApprovalRequestResponse?.status) === 200){
            toast.success(loanApprovalRequestResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`
        } else if(parseInt(loanApprovalRequestResponse?.status) !== 200){
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse])

    useEffect(() => {
        let amount = 0;
        if(parseInt(amountReceived) <= 1000000){
            amount = 20000;
        } else if(parseInt(amountReceived) > 1000000 && parseInt(amountReceived) < 2000000){
            amount = 40000;
        }
        if(amount){
            handleInput(amount, 'amount','','hold_back_Details', );
        }

    }, [amountReceived]);

    useEffect(() => {
        if(checkDisbursalMemo){
            toast.error("Disbursal memo is missing!");
        }
        setCheckDisbursalMemo(false);
    }, [checkDisbursalMemo]);

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Payment Raise'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                <div className="container-v2">
                                    <link rel="stylesheet"
                                          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css"/>
                                    <div id="msform">
                                        <ul id="progressbar">
                                            <li id="confirm" className={`${(stage < 2) ? 'active' : 'done'}`}><span
                                                className='pb-v2'><strong>Payment</strong></span></li>
                                            <li id="confirm"
                                                className={`${(stage == 2) ? 'active' : (stage > 2) ? 'done' : 'inactive'}`}>
                                                <span className='pb-v2'><strong>Dealer</strong></span></li>
                                            <li id="confirm"
                                                className={`${(stage == 3) ? 'active' : (stage > 3) ? 'done' : 'inactive'}`}>
                                                <span className='pb-v2'><strong>Hold Back Amount</strong></span>
                                            </li>
                                            <li id="confirm"
                                                className={`${(stage == 4) ? 'active' : (stage > 4) ? 'done' : 'inactive'}`}>
                                                <span className='pb-v2'><strong>Tranches</strong></span>
                                            </li>
                                            <li id="confirm"
                                                className={`${(stage == 5) ? 'active' : (stage > 5) ? 'done' : 'inactive'}`}>
                                                <span className='pb-v2'><strong>Undertaking</strong></span>
                                            </li>
                                        </ul>


                                    </div>
                                </div>
                                <form onSubmit={(e) => handleSubmit(e, true)}>
                                    {stage === 1 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                                    </div>
                                                    <div className="mb-4 bg-white"> {/*card*/}
                                                        <div className="hide card-header bg-lightGreen-active">
                                                            Payment Details
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="form-group row">
                                                                    <div className="col-sm-6 col-md-6 mt-1 float-field"
                                                                         style={{marginTop: "16px !important"}}>
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleInput(e.target.value, 'existing_loan', e, 'payment_details')

                                                                            }} required>
                                                                            <option value="">Existing Loan</option>
                                                                            <option
                                                                                value="Yes"
                                                                                selected={inputList[0]['payment_details']['existing_loan'] === 'Yes'}>Yes
                                                                            </option>
                                                                            <option
                                                                                value="No"
                                                                                selected={inputList[0]['payment_details']['existing_loan'] === 'No'}>No
                                                                            </option>

                                                                        </select>
                                                                        <label className="large-label float-lb">
                                                                            Existing Loan <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    {inputList[0]['payment_details']['existing_loan'] === 'Yes' &&
                                                                        <>
                                                                            <div
                                                                                className="col-sm-6 col-md-6 mt-1 float-field">
                                                                                <input type="text"
                                                                                       className="form-control form-control-user"
                                                                                       placeholder=" "
                                                                                       onChange={(e) => {
                                                                                           const value = e.target.value
                                                                                               .replace(/[^0-9.]/g, '') // Remove non-numeric and non-decimal characters
                                                                                               .replace(/^(\.)/, '') // Prevent leading decimal points
                                                                                               .replace(/(\..*?)\..*/g, '$1'); // Remove non-numeric characters
                                                                                           handleInput(value, 'for_closure_amount', e, 'payment_details')
                                                                                           e.target.value = value;
                                                                                       }}
                                                                                       value={inputList[0]['payment_details']['for_closure_amount']}
                                                                                       // step="any"      // Allows decimal input
                                                                                       // inputMode="decimal"
                                                                                       required={true}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    Fore Closure Amount <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                </label>
                                                                            </div>

                                                                            <div
                                                                                className="col-sm-6 float-field mb-3">
                                                                                <FileUpload
                                                                                    id={`fc_closure_amount`}
                                                                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                                    documentUrlData={documentUrlDataPublic}
                                                                                    onChange={(val) => {
                                                                                        handleInput(val, 'fc_closure_amount_proof', '', 'payment_details')
                                                                                    }}
                                                                                    prefilledFilename={
                                                                                        (inputList[0]['payment_details']['fc_closure_amount_proof'] || ucdCaseByIdResponse?.data?.fore_closure_amount_proof)
                                                                                            ? "FC Closure Amount Proof"
                                                                                            : ""}
                                                                                >
                                                                                    FC Closure Amount Proof
                                                                                </FileUpload>
                                                                            </div>
                                                                            <div
                                                                                className="col-sm-6 mt-1 float-field"
                                                                                style={{marginTop: "16px !important"}}>
                                                                                <select
                                                                                    className="form-control form-control-user"
                                                                                    onChange={(e) => {
                                                                                        handleInput(e.target.value, 'prev_loan_closure', e, 'payment_details')
                                                                                    }} required={true}>
                                                                                    <option value="">Previous Loan
                                                                                        Closure By
                                                                                    </option>
                                                                                    <option
                                                                                        value="Bank"
                                                                                        selected={inputList[0]['payment_details']['prev_loan_closure'] === 'Bank'}>Bank
                                                                                    </option>
                                                                                    <option
                                                                                        value="Park+"
                                                                                        selected={inputList[0]['payment_details']['prev_loan_closure'] === 'Park+'}>Park+
                                                                                    </option>

                                                                                </select>
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    Previous Loan Closure By <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                </label>
                                                                            </div>
                                                                            {/*{inputList[0]['payment_details']['prev_loan_closure'] === 'Bank' &&*/}
                                                                                <>
                                                                                    <div
                                                                                        className="col-sm-6 mt-1 float-field"
                                                                                        style={{marginTop: "16px !important"}}>
                                                                                        <select
                                                                                            className="form-control form-control-user"
                                                                                            onChange={(e) => {
                                                                                                handleInput(e.target.value, 'mode_of_payment', e, 'payment_details')
                                                                                            }} required={true}>
                                                                                            <option value="">Mode of payment
                                                                                            </option>
                                                                                            <option
                                                                                                value="DD"
                                                                                                selected={inputList[0]['payment_details']['mode_of_payment'] === 'DD'}>DD
                                                                                            </option>
                                                                                            <option
                                                                                                value="RTGS"
                                                                                                selected={inputList[0]['payment_details']['mode_of_payment'] === 'RTGS'}>RTGS
                                                                                            </option>
                                                                                            <option
                                                                                                value="NEFT"
                                                                                                selected={inputList[0]['payment_details']['mode_of_payment'] === 'NEFT'}>NEFT
                                                                                            </option>
                                                                                            <option
                                                                                                value="Other"
                                                                                                selected={inputList[0]['payment_details']['mode_of_payment'] === 'Other'}>Other
                                                                                            </option>

                                                                                    </select>
                                                                                    <label
                                                                                        className="large-label float-lb">
                                                                                        Mode of payment for Loan Closure <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                    </label>
                                                                                </div>
                                                                                    <div
                                                                                        className="col-sm-6 float-field mt-3 mb-2">
                                                                                        <FileUpload
                                                                                            id={`loan_closure_payment_proof`}
                                                                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                                            documentUploadUrl={documentUploadUrlPublic}
                                                                                            documentUrlData={documentUrlDataPublic}
                                                                                            onChange={(val) => {
                                                                                                handleInput(val, 'loan_closure_payment_proof', '', 'payment_details')
                                                                                            }}
                                                                                            required={true}
                                                                                            prefilledFilename={
                                                                                                (inputList[0]['payment_details']['loan_closure_payment_proof'] || ucdCaseByIdResponse?.data?.loan_closure_payment_proof)
                                                                                                    ? "Loan Closure Amount Proof"
                                                                                                    : ""}
                                                                                        >
                                                                                            Loan Closure Amount Proof <i
                                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                                        </FileUpload>
                                                                                    </div>
                                                                                </>
                                                                            {/*}*/}
                                                                            </>
                                                                    }
                                                                    <div
                                                                        className="col-sm-6 col-md-6 mt-1 float-field">
                                                                        <input type="number"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleInput(e.target.value, 'loan_amount_from_bank', e, 'payment_details')
                                                                                   setAmountReceived(e.target.value)
                                                                               }}
                                                                               required
                                                                               value={inputList[0]['payment_details']['loan_amount_from_bank']}
                                                                               step="any"      // Allows decimal input
                                                                               inputMode="decimal"
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Loan Amount Received From Bank <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-6 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleInput(e.target.value, 'utr_no', e, 'payment_details')
                                                                               }}
                                                                               value={inputList[0]['payment_details']['utr_no']}
                                                                               required
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Transaction Proof No <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="date"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleInput(e.target.value, 'disbursal_date', '', 'payment_details')
                                                                               }}
                                                                               value={inputList[0]['payment_details']['disbursal_date']}
                                                                               required={true}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Disbursal Date <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    {console.log(inputList)}
                                                                    <div
                                                                        className="col-sm-6 float-field mb-3">
                                                                        <FileUpload
                                                                            id={`disbursal_memo`}
                                                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                            documentUploadUrl={documentUploadUrlPublic}
                                                                            documentUrlData={documentUrlDataPublic}
                                                                            onChange={(val) => {
                                                                                handleInput(val, 'disbursal_memo', '', 'payment_details')
                                                                            }}
                                                                            required={true}
                                                                            prefilledFilename={inputList[0]['payment_details']['disbursal_memo'] ? "Disbursal Memo" : ""}
                                                                        >
                                                                            Disbursal Memo <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </FileUpload>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </>
                                    }
                                    {stage === 2 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                                    </div>
                                                    <div className="mb-4 bg-white"> {/*card*/}
                                                        <div className="hide card-header bg-lightGreen-active">
                                                            Dealer Details
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="form-group row">
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                                   handleInput(value, 'account_number', e, 'dealer_details')
                                                                                   e.target.value = value;
                                                                               }}
                                                                               disabled={true}
                                                                               value={loanAccountResponse?.DEALER?.account_number}
                                                                               required
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Account Number <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 mt-1 float-field"
                                                                        style={{marginTop: "16px !important"}}>
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleInput(e.target.value, 'bank_name', e, 'dealer_details')

                                                                            }} required disabled={true}>
                                                                            <option value="">Bank Name
                                                                            </option>
                                                                            {bankListResponse.map(val => {
                                                                                return (
                                                                                    <>
                                                                                        <option
                                                                                            value={val?.id}
                                                                                            selected={loanAccountResponse?.DEALER?.bank_name === val?.id}>{val?.id}</option>
                                                                                    </>
                                                                                )
                                                                            })}

                                                                        </select>
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Bank Name <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleInput(e.target.value, 'ifsc_code', e, 'dealer_details')
                                                                               }}
                                                                               required
                                                                               disabled={true}
                                                                               value={loanAccountResponse?.DEALER?.ifsc_code}
                                                                               maxLength={11}
                                                                               minLength={11}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            IFSC Code <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleInput(e.target.value, 'branch_name', e, 'dealer_details')
                                                                               }}
                                                                               required
                                                                               disabled={true}
                                                                               value={loanAccountResponse?.DEALER?.branch_name}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Branch Name <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {stage === 3 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                                    </div>
                                                    <div className="mb-4 bg-white"> {/*card*/}
                                                        <div className="hide card-header bg-lightGreen-active">
                                                            Hold Back Amount
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="form-group row">
                                                                    <div className={`col-sm-6 col-md-6 ${inputList[0]['hold_back_Details']['amount_approval_proof'] ? "mt-2" : "mt-4"} float-field`}>
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   const value = e.target.value
                                                                                       .replace(/[^0-9.]/g, '') // Remove non-numeric and non-decimal characters
                                                                                       .replace(/^(\.)/, '') // Prevent leading decimal points
                                                                                       .replace(/(\..*?)\..*/g, '$1'); // Remove non-numeric characters
                                                                                   handleInput(value, 'amount', e, 'hold_back_Details')
                                                                                   e.target.value = value
                                                                               }}
                                                                               required
                                                                               value={inputList[0]['hold_back_Details']['amount']}
                                                                               step="any"      // Allows decimal input
                                                                               inputMode="decimal"
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Hold Back Amount <i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                    </div>

                                                                    <div className="col-sm-6 col-md-6 float-field mb-3">
                                                                        <FileUpload
                                                                            id={`amount_approval_proof`}
                                                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                            documentUploadUrl={documentUploadUrlPublic}
                                                                            documentUrlData={documentUrlDataPublic}
                                                                            onChange={(val) => {
                                                                                handleInput(val, 'amount_approval_proof', '', 'hold_back_Details')
                                                                            }}
                                                                            required={true}
                                                                            prefilledFilename={(inputList[0]['hold_back_Details']['amount_approval_proof'] || ucdCaseByIdResponse?.data?.hold_back_amount_proof)
                                                                                ?
                                                                                "Hold Back Amount Approval" : ""}
                                                                        >
                                                                            Amount approval document<i
                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                        </FileUpload>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-2">
                                                                        <div className="card-header " style={{"background-color": "rgb(71, 51, 129)" ,"color": "white"}}>
                                                                            Hold Back Amount Release Tranches
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                                    <div className="user">
                                                                                        <div className="form-group row">
                                                                                            <div
                                                                                                className="col-sm-6 col-md-6 mt-1 float-field"
                                                                                                style={{marginTop: "16px !important"}}>
                                                                                                <select
                                                                                                    className="form-control form-control-user"
                                                                                                    onChange={(e) => {
                                                                                                        handleInput(e.target.value, 'account_id', '', 'hold_back_Details')

                                                                                                    }} required>
                                                                                                    <option
                                                                                                        value="">Select
                                                                                                        Account
                                                                                                    </option>
                                                                                                    {loanAccountResponse?.accounts && loanAccountResponse?.accounts.map(val => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                <option
                                                                                                                    value={val?.id}
                                                                                                                    selected={parseInt(loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id) === parseInt(val?.id)}>{val?.name}</option>
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                                </select>
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    Account <i
                                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                                </label>
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-sm-6 col-md-6 mt-1 float-field"
                                                                                                style={{marginTop: "16px !important"}}>
                                                                                                <select
                                                                                                    className="form-control form-control-user"
                                                                                                    onChange={(e) => {
                                                                                                        handleInput(e.target.value, 'mode_of_payment', '', 'hold_back_Details')

                                                                                                    }} required>
                                                                                                    <option
                                                                                                        value=""
                                                                                                        >Select Mode of payment
                                                                                                    </option>
                                                                                                    <option
                                                                                                        value="DD"
                                                                                                        selected={loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode === 'DD'}>DD
                                                                                                    </option>
                                                                                                    <option
                                                                                                        value="RTGS"
                                                                                                        selected={loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode === 'RTGS'}>RTGS
                                                                                                    </option>
                                                                                                    <option
                                                                                                        value="NEFT"
                                                                                                        selected={loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode === 'NEFT'}>NEFT
                                                                                                    </option>
                                                                                                    <option
                                                                                                        value="Other"
                                                                                                        selected={loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode === 'Other'}>Other
                                                                                                    </option>

                                                                                                </select>
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    Mode of payment <i
                                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                                </label>
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-sm-6 col-md-6 mt-3 float-field">
                                                                                                <input type="text"
                                                                                                       className="form-control form-control-user"
                                                                                                       placeholder=" "
                                                                                                       onChange={(e) => {
                                                                                                           handleInput(e.target.value, 'remark', '', 'hold_back_Details')
                                                                                                       }}
                                                                                                       required
                                                                                                       value={inputList[0]['hold_back_Details']['remark']}
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    Remark <i
                                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                        </div>
                                                                    </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {stage === 4 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                                    </div>
                                                    <div className="mb-4 bg-white"> {/*card*/}
                                                        <div className="hide card-header bg-lightGreen-active">
                                                            Tranches
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="form-group row">
                                                                    {tranches.map((val, i) => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    className="col-sm-6 col-md-6 mt-1 float-field">
                                                                                    <input type="text"
                                                                                           className="form-control form-control-user"
                                                                                           placeholder=" "
                                                                                           onChange={(e) => {
                                                                                               const value = e.target.value
                                                                                                   .replace(/[^0-9.]/g, '') // Remove non-numeric and non-decimal characters
                                                                                                   .replace(/^(\.)/, '') // Prevent leading decimal points
                                                                                                   .replace(/(\..*?)\..*/g, '$1'); // Remove non-numeric characters
                                                                                               handleTrancheInput(value, 'amount', i)
                                                                                               e.target.value = value
                                                                                           }}
                                                                                           required
                                                                                           value={val['amount']}
                                                                                           step="any"      // Allows decimal input
                                                                                           inputMode="decimal"
                                                                                    />
                                                                                    <label
                                                                                        className="large-label float-lb">
                                                                                        Tranche Amount <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    className="col-sm-6 mt-1 float-field"
                                                                                    style={{marginTop: "16px !important"}}>
                                                                                    <select
                                                                                        className="form-control form-control-user"
                                                                                        onChange={(e) => {
                                                                                            handleTrancheInput(e.target.value, 'account_id', i)

                                                                                        }} required>
                                                                                        <option value="">Select Account
                                                                                        </option>
                                                                                        {loanAccountResponse?.accounts && loanAccountResponse?.accounts.map(value => {
                                                                                            return (
                                                                                                <>
                                                                                                    <option
                                                                                                        value={value?.id}
                                                                                                        selected={parseInt(val?.account_id) === parseInt(value?.id)}>{value?.name}</option>
                                                                                                </>
                                                                                            )
                                                                                        })}

                                                                                    </select>
                                                                                    <label
                                                                                        className="large-label float-lb">
                                                                                        Account <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    className="col-sm-6 col-md-6 mt-1 float-field"
                                                                                    style={{marginTop: "16px !important"}}>
                                                                                    <select
                                                                                        className="form-control form-control-user"
                                                                                        onChange={(e) => {
                                                                                            handleTrancheInput(e.target.value, 'payment_mode', i)

                                                                                        }} required>
                                                                                        <option value="">Select Mode of
                                                                                            payment
                                                                                        </option>
                                                                                        <option
                                                                                            value="DD"
                                                                                            selected={val['payment_mode'] === 'DD'}>DD
                                                                                        </option>
                                                                                        <option
                                                                                            value="RTGS"
                                                                                            selected={val['payment_mode'] === 'RTGS'}>RTGS
                                                                                        </option>
                                                                                        <option
                                                                                            value="NEFT"
                                                                                            selected={val['payment_mode'] === 'NEFT'}>NEFT
                                                                                        </option>
                                                                                        <option
                                                                                            value="Other"
                                                                                            selected={val['payment_mode'] === 'Other'}>Other
                                                                                        </option>

                                                                                    </select>
                                                                                    <label
                                                                                        className="large-label float-lb">
                                                                                        Mode of payment <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    className="col-sm-6 col-md-6 mt-1 float-field">
                                                                                    <input type="text"
                                                                                           className="form-control form-control-user"
                                                                                           placeholder=" "
                                                                                           onChange={(e) => {
                                                                                               handleTrancheInput(e.target.value, 'remark', i)
                                                                                           }}
                                                                                           required
                                                                                           value={val?.remark}
                                                                                    />
                                                                                    <label
                                                                                        className="large-label float-lb">
                                                                                        Remark <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    className="btn-box mb-4"
                                                                                    style={{"width": "100%"}}>
                                                                                    {tranches.length !== 1 &&
                                                                                        <button
                                                                                            onClick={(e) => handleRemoveTranches(e, i)}
                                                                                            className="btn btn-sm btn-danger ml-3">Remove
                                                                                            Tranche
                                                                                        </button>
                                                                                    }
                                                                                    {tranches.length - 1 === i &&
                                                                                        <button
                                                                                            className="btn btn-sm btn-primary ml-3 mt-1"
                                                                                            onClick={(e) => handleAddTranches(e)}>Add
                                                                                            Another Tranche
                                                                                        </button>
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {stage === 5 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                                    </div>
                                                    <div className="mb-4 bg-white"> {/*card*/}
                                                        <div className="hide card-header bg-lightGreen-active">
                                                            Undertaking
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="form-group row">

                                                                    <div className="col-sm-6 float-field mb-3">
                                                                        <FileUpload
                                                                            id={`undertaking`}
                                                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                            documentUploadUrl={documentUploadUrlPublic}
                                                                            documentUrlData={documentUrlDataPublic}
                                                                            onChange={(val) => {
                                                                                handleInput(val, 'undertaking', '', 'undertaking')
                                                                            }}
                                                                            required={true}
                                                                            prefilledFilename={(inputList[0]['undertaking']['undertaking'] ||
                                                                                ucdCaseByIdResponse?.data?.customer_undertaking) ? "Undertaking" : ""}
                                                                        >
                                                                            Undertaking
                                                                        </FileUpload>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className="d-flex">
                                        {parseInt(stage) > 1 &&
                                            <div className="col-md-6">
                                                <button
                                                    className="btn btn-primary btn-user btn-block submit-btn"
                                                    onClick={(e) => {
                                                        handleStage(stage - 1)
                                                    }}>
                                                    Go Back
                                                </button>
                                            </div>
                                        }

                                        {parseInt(stage) <= 4 &&
                                            <div className="col-md-6">
                                                <button
                                                    className="btn btn-primary btn-user btn-block submit-btn"
                                                    onClick={(e) => {
                                                        handleStage(stage + 1)
                                                    }}>
                                                    Next
                                                </button>
                                            </div>
                                        }

                                        {parseInt(stage) === 5 &&
                                            <div className="col-md-6">
                                                <button
                                                    className="btn btn-primary btn-user btn-block submit-btn"
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </form>

                                {ucdCaseByIdResponse?.data?.loan_amount_received_from_bank &&
                                    <div className="col-md-6 mt-4">
                                        <button
                                            className="btn btn-primary btn-user btn-block submit-btn"
                                            onClick={handlePaymentRelease}
                                        >
                                            Request For Payment Release
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default RaisePayment